import AbtProductOverview from '../../pages/abt/AbtProductOverview'
import AbtPayment from '../../pages/abt/AbtPayment'
import { overrideFromWebsiteCookie } from '../../website-integration/region-manager'
import type Store from 'vuex'
import SubscriptionManager from '../../subscription/subscription-manager'

export default (store: Store, subscriptionManager: SubscriptionManager) => {
  return [
    {
      path: '/:lang/flow',
      name: 'AbtProductOverview',
      component: AbtProductOverview,
      beforeEnter: (to, from, next) => {
        overrideFromWebsiteCookie() // this method is async, but we do not need to wait for it to finish
        next()
      }
    },
    {
      path: '/:lang/flow-webshop/payment',
      name: 'AbtPayment',
      component: AbtPayment,
      beforeEnter: function (to, from, next) {
        if (!store.state.cart.priceSpecification) {
          next({name: 'AbtProductOverview', params: to.params})
        }
        next()
      }
    },
    {
      path: '/:lang/flow-webshop',
      redirect: {name: 'AbtProductOverview'}
    },
    {
      path: '/:lang/flow-webshop/products/renew/:token',
      name: 'AbtSubscriptionRenewal',
      beforeEnter: async (to, from, next) => {
        await store.dispatch('selection/fetchFilters')
        const destination = await {
          name: 'AbtProductOverview',
          params: to.params,
          query: await subscriptionManager.buildAbtSubscriptionRenewalDeeplinkParameters(to.params.token)
        }
        next(destination)
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/routes/abt/index.js